import Vue from 'vue';
import Router from 'vue-router';
import Chat from '@/views/Chat.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/chat',
			name: 'chat',
			component: Chat,
		},
		{
			path: '/',
			name: 'login',
			component: () => import('@/views/Login.vue'),
		},
		// ... additional routes can be added here later
	],
});
